import React from 'react';

const SettingsMenu = ({
  xAxis,
  zAxis,
  setXAxis,
  setZAxis,
  floors, 
  setFloors,
  selectedFloor, // Nueva propiedad para el piso seleccionado
  setSelectedFloor, // Función para cambiar el piso seleccionado
  spacingMatrix, 
  setSpacingMatrix,
  totalVolume,
  totalWeight,
  totalArea,

  selectedSpacing
}) => 
  {

  const handleChange = (index, value) => 
  {
    const updatedMatrix = [...spacingMatrix];

    const min = 2;
    const max = 12;
  
    // Verificar si el valor es nulo, vacío o cero
    const parsedValue = parseFloat(value);

    if (isNaN(parsedValue) || parsedValue < min || parsedValue > max)
    {
      alert(`Ingrese un valor entre ${min} y ${max} metros`);
      return;
    }
  
    updatedMatrix[index].spacing = parsedValue;
    setSpacingMatrix(updatedMatrix);
  };  

  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold text-center mb-5 border-b-4 uppercase">
        Ejes
      </h2>

      <h3 className="text-lg font-semibold">Geometría</h3>
      
      <div className="mt-4 flex space-x-4">
        <div>
          <label htmlFor="ejeX" className="block">Eje X</label>
          <input            
            type="number"
            value={xAxis}
            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 2;
                const max = 10;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max}`);
                  return;
                }
          
                setXAxis(value);
              }}
            className="p-2 mt-1 border border-gray-400 rounded w-full"
            min="2"  // Establecer valor mínimo de 2
            max="10"
          />
        </div>

        <div>
          <label htmlFor="ejeY" className="block">Eje Y</label>
          <input
            type="number"
            value={zAxis}
            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 2;
                const max = 10;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max}`);
                  return;
                }
          
                setZAxis(value);
              }}
            className="p-2 mt-1 border border-gray-400 rounded w-full"
            min="2"  // Establecer valor mínimo de 2
            max="10"
          />
        </div>
      </div>

      {/* Número de Pisos */}
      <div className="mb-2">
        <label htmlFor="storyNumber" className="block">Número de Pisos</label>
        <input 
          type="number" 
          value={floors} 
          onChange={(e) => 
            {
              const value = Number(e.target.value);
              const min = 1;
              const max = 3;
        
              if (isNaN(value) || value < min || value > max) {
                alert(`Ingrese un valor entre ${min} y ${max}`);
                return;
              }
        
              setFloors(value);
            }}
          className="p-2 mt-1 border border-gray-400 rounded w-full"
          min="1" max="3"
        />
      </div>

      {/* Volumen en metros cúbicos */}
      <div className="mb-2">
        <label htmlFor="storyNumber" className="block">Volumen en Metros Cúbicos</label>
        <span 
          type="number" 
          className="p-2 mt-1 rounded w-full"
        >
          {totalVolume}
          &nbsp;
          Metros Cúbicos
        </span>
      </div>

      {/* Peso en Toneladas */}
      <div className="mb-2">
        <label htmlFor="storyNumber" className="block">Peso en Toneladas</label>
        <span 
          type="number" 
          className="p-2 mt-1 rounded w-full"
        >
          {totalWeight}
          &nbsp;
          Toneladas
        </span>
      </div>

      {/* Área en metros cuadrados */}
      <div className="mb-2">
        <label htmlFor="storyNumber" className="block">Área en Metros Cuadrados</label>
        <span 
          type="number" 
          className="p-2 mt-1 rounded w-full"
        >
          {totalArea}
          &nbsp;
          m2
        </span>
      </div>


      

      {/* Piso Seleccionado */}
      <div className="mb-2">
        <label htmlFor="selectedFloor" className="block">Piso Seleccionado</label>
        <select
          value={selectedFloor}
          onChange={(e) => setSelectedFloor(Number(e.target.value))}
          className="p-2 mt-1 border border-gray-400 rounded w-full"
        >
          {/* Opciones de Piso */}
          {[...Array(floors + 1).keys()].map(floor => (
            <option key={floor} value={floor}>
              Piso {floor}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-2">
        <h2 className="block">Separaciones</h2>
        
        <div className="p-4 border rounded bg-white shadow-md">
          <h2 className="text-lg font-bold mb-2">Separaciones de Ejes</h2>
          <table className="border-collapse border border-gray-300 w-full text-center">
            <thead>
              <tr>
                <th className="border border-gray-300 p-2">Sección</th>
                <th className="border border-gray-300 p-2">Espaciado (m)</th>
              </tr>
            </thead>
            <tbody>
              {spacingMatrix.map((item, index) => (
                selectedSpacing === item.section && (
                  <tr key={item.section}>
                    <td className="border border-gray-300 p-2">{item.section}</td>
                    <td className="border border-gray-300 p-2">
                      <input
                        type="number"
                        step="0.05"
                        min="2"
                        max="12"
                        value={item.spacing}
                        onChange={(e) => handleChange(index, e.target.value)}
                        className="w-16 text-center border rounded"
                      />
                    </td>
                  </tr>
                )
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SettingsMenu;